import styled from "styled-components";

export const StyledThumbnailContainer = styled.div`
  padding-bottom: 1.75rem;
  align-content: center;
`;
